import { isNumber } from 'utils/common'
import Vue from 'vue'
const GREEN_COLOR = 'rgb(60, 200, 100, 0.7)'
const GREEN_COLOR_FADE = 'rgba(60, 200, 100, 0)'
const RED_COLOR = 'rgb(255, 74, 74, 0.7)'
const RED_COLOR_FADE = 'rgba(255, 74, 74, 0)'
const STYLE = `
  @keyframes blink {
    50% {
      opacity: 6;
    }
  }

  .blink-active-true .blink {
    position: relative;
  }
  .blink-active-true .blink::before {
    content: ' ';
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    animation: blink .7s linear infinite;
  }
  .blink-active-true .blink.border::before {
    background: none;
  }

  .blink-active-true .blink::before {
    background: linear-gradient(to right, transparent 0%, currentColor 100%);
  }
  .blink-active-true .blink.border::before {
    border: 1px solid currentColor;
  }

  .blink-active-true .blink.up::before {
    background: linear-gradient(to right, ${GREEN_COLOR_FADE} 0%, ${GREEN_COLOR} 100%);
  }
  .blink-active-true .blink.border.up::before {
    border: 1px solid ${GREEN_COLOR};
  }
  .stock-color--red-up.blink-active-true .blink.up::before {
    background: linear-gradient(to right, ${RED_COLOR_FADE} 0%, ${RED_COLOR} 100%);
  }
  .stock-color--red-up.blink-active-true .blink.border.up::before {
    border: 1px solid ${RED_COLOR};
  }

  .blink-active-true .blink.down::before {
    background: linear-gradient(to right, ${RED_COLOR_FADE} 0%, ${RED_COLOR} 100%);
  }
  .blink-active-true .blink.border.down::before {
    border: 1px solid ${RED_COLOR};
  }
  .stock-color--red-up.blink-active-true .blink.down::before {
    background: linear-gradient(to right, ${GREEN_COLOR_FADE} 0%, ${GREEN_COLOR} 100%);
  }
  .stock-color--red-up.blink-active-true .blink.border.down::before {
    border: 1px solid ${GREEN_COLOR};
  }
`
const styles = document.createElement('style')
styles.innerHTML = STYLE
document.querySelector('head').appendChild(styles)

const getStyle = (diff, isShowBorder, hideUpDown) => {
  const list = ['blink']
  if (isNumber(diff)) {
    const change = diff < 0 ? 'up' : 'down'
    if (diff && !hideUpDown) {
      list.push(change)
    }
    if (isShowBorder) {
      list.push('border')
    }
  }
  return list
}

Vue.directive('blink', {
  bind(el, binding) {
    const isShowBorder = binding.modifiers.border
    const hideUpDown = binding.modifiers.upDown
    const initBlink = binding.arg
    el.__blinkHandler__ = function(diff) {
      const style = getStyle(diff, isShowBorder, hideUpDown)
      el.classList.add(...style)
      return window.setTimeout(() => {
        el.classList.remove(...style)
      }, 700)
    }
    if (initBlink) {
      el.__blinkHandler__()
    }
  },
  update(el, binding) {
    if (binding.oldValue === binding.value) return
    const diff = binding.oldValue - binding.value
    if (!isNaN(diff) && diff !== 0) {
      window.clearTimeout(el.__currentTimer__)
      el.__currentTimer__ = el.__blinkHandler__(diff)
    }
  }
})
